module.exports = __webpack_public_path__ + "img/douglasville_banner.png";